import { of } from 'rxjs';
import { BusinessAccountRequestLabel, BusinessAccountRequestState, BusinessAccountsGridData, EditAdminCompanyDetailsAemLabels, Grid } from '../components/business-account-request';
import { mockData } from './mock-auth-data';
import { ApiResponse } from '../definitions/api-response.interface';
import { SharedFactoryDataService } from '../services/shared/shared-factory-data.service';
import { AprRejBtnType, AprRejUserData, GridValue } from 'kinetic-angular';
import { mockUploadFileAemResponse } from './business-account-request-upload-data';
import { locationHeirarchyObject } from './location-heirarchy-mock';

export const mockGridData: Grid = {
	headers: [
		{ id: '001', label: 'Requested On' },
		{ id: '002', label: 'Primary GRID' },
		{ id: '003', label: 'Primary Company Details' },
		{ id: '004', label: 'Contact' },
		{ id: '005', label: 'Locations List' },
		{ id: '006', label: 'Business Account Approval' }],
	accept: { label: 'Accept', iconPath: '', altText: 'Accept' },
	reject: { label: 'Reject', iconPath: '', altText: 'Reject' },
	tooltip: 'Please review \'Locations List\' to activate Accept/Reject button',
	uploadFile: 'Upload New',
	companyGridLabel: 'GRID',
	noResult: { label: 'No business account requests', iconPath: '', altText: '' },
	uploadFileLabels: mockUploadFileAemResponse
};
export const mockBusinessAccountHeaders: BusinessAccountRequestLabel =
{
	pageHeading: 'Business Account Request Management',
	tableHeading: 'Business Account Requests',
	grid: mockGridData
};
export const mockBusinessAccountData: BusinessAccountsGridData[] = [{
	profileInformation: {
		firstName: 'Test-BA',
		lastName: 'Test-BA',
		email: 'ba-test@yopmail.com',
		phoneNumber: '123456789'
	},
	companyDetails: {
		primaryLocationGRID: '1234',
		companyName: 'TRACTOR',
		addressLine1: '5401 Virginia Way',
		addressLine2: '',
		city: 'Brentwood',
		state: 'TN',
		zipCode: '37027-7536',
		country: 'US',
		adminGrid: '456720'
	},
	pendingLocationDetails: {
		erroredFileName: 'TMH Approval File Name',
		originalFileName: 'TMH Approval File Name',
		updatedFileName: 'TMH Approval File Name',
		locationListReviewed: false,
		primaryGridOnly: false
	},
	tempUserID: 'dfa1c3a1-777f-4f93-8e12-d013b5bc3eae111',
	requestedOn: 1688110318300,
	topLevelGrid: '1234',
	pendingUsers: [],
	dealerInfo: undefined
}];
export const mockEditAdminCompanyDetailsAemLabels: EditAdminCompanyDetailsAemLabels =
{
	heading: '',
	closeIcon: { iconPath: '', altText: '' },
	errorText: {
		invalidCharacterWithNumericErrorMessage: 'Please enter only letters, numbers, hyphens, apostrophe, commas or periods',
		invalidCharacterWithoutNumericErrorMessage: 'Please enter a valid character',
		requiredErrorMessage: '$token is a required field',
		minLengthZipCodeError: 'Postal code should have 5 numeric characters',
		canadaPostalCodeFormatError: 'Postal Code format is incorrect. Please enter the correct Postal Code'
	},
	pageLabels: {
		companyName: { id: '', label: 'Company Name' },
		addressLine1: { id: '', label: 'Address Line 1' },
		addressLine2: { id: '', label: 'Address Line 2 (Optional)' },
		country: { id: '', label: 'Country' },
		city: { id: '', label: 'City' },
		state: { id: '', label: 'State/Province' },
		zipCode: { id: '', label: 'Postal Code' }
	},
	pageButtons: [{ cancel: { id: '', label: 'Cancel' }, save: { id: '', label: 'Save' } }]
};

export const mockedState: BusinessAccountRequestState = {
	sectionTop: { pageHeading: '' },
	sectionMiddle: {
		tableHeading: '',
		grid: mockGridData,
		tableState: {
			gridHeaders: [{ label: '' }, { label: '' }, { label: '' }, { label: '' }, { label: '' }, { label: '' }, { label: '' }],
			gridData: [
				{
					values: [{
						label: '',
						value: '',
						ctaList: [{
							id: '',
							className: AprRejBtnType.singleApprove,
							state: {
								size: 'medium',
								style: 'link',
								disabled: false,
								label: '',
								icon: { altText: '', iconPath: '' },
								position: 'none'
							}
						},
						{
							id: '',
							className: AprRejBtnType.singleReject,
							state: {
								size: 'medium',
								style: 'link',
								disabled: false,
								label: '',
								icon: { altText: '', iconPath: '' },
								position: 'none'
							}
						}
						]
					}, 
					{ label: '', value: '', ctaList: [] },
					{ label: '', value: '', ctaList: [] },
					{ label: '', value: '', ctaList: [] },
					{ label: '', value: '', ctaList: [] },
					{ label: '', value: '', ctaList: [] }],
					id: '1234',
					email: '',
					state: '',
					company: '',
					roles: [],
					portalApprovedCustomerID: [],
					phoneNumber: '',
					roleName: ''
				}
			],
			loading: false,
			isTooltipPresent: true,
			tooltip: { content: '', closeIcon: SharedFactoryDataService.buildImage('/assets/tooltip-close-icon.svg', '') },
			id: 'business-account',
			ribbon: {
				ctaList: [],
				cancelButton: {
					size: 'medium',
					style: 'link',
					disabled: false,
					label: '',
					icon: { altText: '', iconPath: '' },
					position: 'none'
				}
			},
			isCheckbox: false,
			isRibbon: false,
			itemsSelected: '',
			noResult: {
				image: { iconPath: '/assets/access-requests-not-found.svg', altText: '' },
				text: ''
			}
		},
		errorState: { messages: [], id: '', statusCode: 401, image: { iconPath: '', altText: '' } },
		businessAccountData: []
	}
};
export const mockCompanyDetailsResponse: BusinessAccountsGridData = {
	profileInformation: {
		firstName: 'Test-BA',
		lastName: 'Test-BA',
		email: 'ba-test@yopmail.com',
		phoneNumber: '123456789'
	},
	companyDetails: {
		primaryLocationGRID: '1234',
		companyName: 'TRACTOR SUPPLY COMPANY',
		addressLine1: '5401 Virginia Way',
		addressLine2: '',
		city: 'Brentwood',
		state: 'TN',
		zipCode: '37027-7536',
		country: 'US',
		adminGrid: '106727'
	},
	pendingLocationDetails: {
		erroredFileName: '',
		originalFileName: '',
		updatedFileName: '',
		locationListReviewed: false,
		primaryGridOnly: false
	},
	tempUserID: 'dfa1c3a1-777f-4f93-8e12-d013b5bc3eae111',
	requestedOn: 1688110318300,
	topLevelGrid: '106727',
	pendingUsers: [],
	dealerInfo: {
		dealerName: 'Test Dealer',
		dealerId: '123456',
		dealerEmail: ''
	}
};

export const mockPendingBaList: BusinessAccountsGridData[] = [{
	profileInformation: {
		firstName: 'Test-BA',
		lastName: 'Test-BA',
		email: 'vivek.mayya@accenture.com',
		phoneNumber: '123456789'
	},
	companyDetails: {
		primaryLocationGRID: '104802',
		companyName: 'TRACTOR SUPPLY COMPANY',
		addressLine1: '4035 Piedmont Pkwy',
		addressLine2: '',
		city: 'Brentwood',
		state: 'TN',
		zipCode: '37027-7536',
		country: 'US',
		adminGrid: '106727'
	},
	pendingLocationDetails: {
		originalFileName: '',
		updatedFileName: '',
		erroredFileName: '',
		locationListReviewed: false,
		primaryGridOnly: false
	},
	tempUserID: 'dfa1c3a1-777f-4f93-8e12-d013b5bc3eae111',
	requestedOn: 1688110318300,
	topLevelGrid: '37503594',
	pendingUsers: [],
	dealerInfo: undefined
}];
export const mockSectionMiddleTableStateGrid = [{
	checked: false,
	email: 'abc@gmail.com',
	id: '123',
	state: 'WI',
	values: [],
	company: 'ACTIS MANUFACTURING LLC',
	roles: ['d345b32d-642e-45d9-a5dd-f273b1e2203b'],
	portalApprovedCustomerID: ['2137935'],
	phoneNumber: '9876543210',
	roleName: 'Default User'
},
{
	checked: false,
	email: 'xyz@gmail.com',
	id: '789',
	state: 'WI',
	values: [],
	company: 'ACTIS MANUFACTURING LLC',
	roles: ['d345b32d-642e-45d9-a5dd-f273b1e2203c'],
	portalApprovedCustomerID: ['2137936'],
	phoneNumber: '9876543210',
	roleName: 'Default User'
}];
export const mockRejectedUser : AprRejUserData[] = [{ id: '', email: 'abc@gmail.com', state: '' }];
export const mockSectionMiddleTableStateGrid1: GridValue[] = [{
	values: [
		{ label: '', value: '', ctaList: [] },
		{ label: '', value: '', ctaList: [] },
		{ label: '', value: '', ctaList: [] },
		{ label: '', value: '', ctaList: [] },
		{ label: '', value: '', ctaList: [] },
		{
			label: '',
			value: '',
			ctaList: [{
				id: '',
				className: AprRejBtnType.bulkApprove,
				state: {
					size: 'medium',
					style: 'link',
					disabled: false,
					label: '',
					icon: { altText: '', iconPath: '' },
					position: 'none'
				}
			},
			{
				id: '',
				className: AprRejBtnType.bulkReject,
				state: {
					size: 'medium',
					style: 'link',
					disabled: false,
					label: '',
					icon: { altText: '', iconPath: '' },
					position: 'none'
				}
			}]
		}],
	id: 'dfa1c3a1-777f-4f93-8e12-d013b5bc3eae1113',
	email: '',
	state: '',
	company: '',
	roles: [],
	portalApprovedCustomerID: [],
	phoneNumber: '',
	roleName: ''
}];
export class FakeApiService 
{
	public getBusinessAccountRequestAemLabel() 
	{
		return of(mockBusinessAccountHeaders);
	}
	public getEditAdminCompanyDetailsAemLabels() 
	{
		return of(mockEditAdminCompanyDetailsAemLabels);
	}
	public getLoggedInUserObs() 
	{
		return of({ data: mockData });
	}
	public getLoggedInUserLocations() 
	{
		return of({ data: locationHeirarchyObject });
	}
	public getBusinessAccountRequestData() 
	{
		return of({ data: mockBusinessAccountData });
	}
	public rejectBusinessAccount() 
	{
		return of({
			success: true,
			message: 'User updated successfully',
			statusCode: 200,
			data: {}
		} as unknown as ApiResponse);
	}
	public downloadLocationList() 
	{
		return of({});
	}
	public updateAdminCompanyDetails() 
	{
		return of({
			success: true,
			message: 'Grid and Address Udpated',
			statusCode: 200,
			data: {}
		});
	}
	public approveBusinessAdminAccount()
	{
		return of({
			statusCode: 201,
			success: true,
			message: 'Request successfully approved.',
			data: {}
		} as unknown as ApiResponse);
	}
	public getServerValidationUploadFile()
	{
		return of({
			success: true,
			message: 'Success',
			statusCode: 201,
			data: {
				fileStatus: 'Upload Submitted',
				updatedFileName: 'TMH Approve File_Corporate_Admin_New Locations_List1_success_data_paluser_1692702271812.xlsx'
			}
		});
	}
}
